import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/services/auth/auth.service';
import { environment } from 'src/environments/environment';
import { ConfigService } from 'src/app/services/config/config.service';
import { TelecomService } from 'src/app/services/telecom/telecom.service';

@Component({
  selector: 'app-disposition',
  templateUrl: './disposition.component.html',
  styleUrls: ['./disposition.component.css']
})
export class DispositionComponent implements OnInit {

  //data
  filteredData: Array<any> = [];
  filteredDispositionGroups: Array<any> = [];

  //retrieved data
  lobList: Array<any> = [];
  dispositionList: Array<any> = [];
  dispositionGroups: Array<any> = [];

  //selector
  lobSelect: string = null;
  dispositionGroupSelect: String = "DEFAULT";

  //other
  lambdaError: boolean = false;
  lambdaMessage: string = '';
  formValid: boolean = false;
  isTelecom: boolean = false;
  bluePrint: any = {"LOB": "", callType:"BOTH", groupId:"DEFAULT", "disposition": {"status": "Enabled", "text": "", "description": ""}};
  dispositionGroupUrl: String = "/dispositionGroups"

  constructor(private authService: AuthService, private configService: ConfigService, private telecomService:TelecomService){ }

  ngOnInit() {
    this.isTelecom = this.authService.memberOf.includes(environment.roles.telecom);
    this.lobSelect = this.configService.activeLOB;
    
    this.bluePrint.LOB = this.lobSelect;
    if(this.lobSelect == null){
      this.lobSelect = 'DEFAULT';
    }
    if(this.configService.activeLOB){
      this.dispositionGroupUrl = '/' + this.configService.activeLOB + this.dispositionGroupUrl;
    }
    console.log(this.dispositionGroupUrl);
    this.getData();
    this.getDispositionGroups();
  }

  getData(){
    // get lobs
    this.telecomService.getLOBs().then((resultData:any)=>{
      console.log("get lob result: ", resultData);
      this.lobList = resultData.lobList;
    });
    //if dispositions empty, do not display no data message until table appears
    if(this.lobSelect != "DEFAULT"){
      this.getDispositions();
    }
  }

  getDispositions(){
    this.telecomService.getRows(environment.dispositionLambdaName).then((response: any) => {
      if(response.statusCode == 200){
        this.dispositionList = response.body.Items;
        if(this.dispositionList.length == 0){
          this.lambdaError = false;
          this.lambdaMessage = 'No data to display'
        }
        this.filterDispositions();
      }
      else{
        this.lambdaError = true;
        this.lambdaMessage = response.Error.message;
        console.error(response.Error)
      }
    });
  }

  getDispositionGroups(){
    this.telecomService.getRows(environment.DispositionGroupsLambdaName).then((data: any) => {
      if(data.statusCode == 200){
        this.dispositionGroups = data.body.Group.Item.data;
        this.filteredDispositionGroups = this.dispositionGroups;
        this.filteredDispositionGroups = this.dispositionGroups.filter((group) => {return (group.LOB == this.lobSelect || this.lobSelect == 'DEFAULT')});
      }
      else{
        this.lambdaError = true;
        this.lambdaMessage = data.Error.message;
        console.log("Error: ", data.Error)
      }
    });
  }

  //filter what data is shown in the data grid
  filterDispositions(){
    if(this.lobSelect != 'DEFAULT'){
      let temp = [];
      for(let x = 0; x < this.dispositionList.length; x++){
        if(this.dispositionList[x].LOB == this.lobSelect){
          if(this.dispositionList[x].groupId == this.dispositionGroupSelect || (this.dispositionGroupSelect == "DEFAULT" && (!this.dispositionList[x].groupId || this.dispositionList[x].groupId == "DEFAULT"))){
            temp.push(this.dispositionList[x]);
          }
        }
      }
      this.filteredData = temp;
      if(this.filteredData.length == 0){
        this.lambdaError = false;
        this.lambdaMessage = 'No data to display';
      }
    }
  }

  handleDispositionButton(event: any){
    console.info(event);
    if(event.button === "confirm"){
      this.updateItem(event.item);
    }
  }

  //put
  updateItem(item: any){

    let params = {
      FunctionName: environment.dispositionLambdaName,
      Payload: JSON.stringify({
        operation: 'put',
        data: item
      })
    };

    this.telecomService.callLambda(params, "Failed to update disposition table.").then((response: any) => {
      if(response.statusCode == 200){
        this.lambdaError = false;
        this.lambdaMessage = "Data saved successfully";
        item.item = response.body.Item;
        this.updateLocalData(item.item);
      }else{
        this.lambdaError = true;
        this.lambdaMessage = response.Error.message;
        console.error(response.Error);
      }
    });
  }

  //update local data at appropriate index
  updateLocalData(item: any){
    let found = false;
    for(let x=0; x < this.dispositionList.length; x++){
      if(item.code == this.dispositionList[x].code && item.LOB == this.dispositionList[x].LOB){
        this.dispositionList[x] = item;
        found = true;
        break;
      }
    }
    if(!found){
      this.dispositionList.unshift(item);
    }
    this.filterDispositions();
  }

  selectChange(){
    console.log("selectChange fired");
    this.lambdaMessage = '';
    this.bluePrint.LOB = this.lobSelect;
    this.configService.setLOB(this.lobSelect);
    this.bluePrint.groupId = this.dispositionGroupSelect;
    this.filteredDispositionGroups = this.dispositionGroups.filter((group) => {return (group.LOB == this.lobSelect || this.lobSelect == 'DEFAULT')});
    if(this.dispositionList.length == 0){
      this.getDispositions();
    }else{
      this.filterDispositions();
    }
  }

  validate(item: any){
    this.formValid = false;
    this.lambdaMessage = '';

    if(item.disposition.text.length < 3){
      this.lambdaMessage = 'Disposition is too short';
      this.lambdaError = true;
      return;
    }

    if(item.disposition.description.length < 3){
      this.lambdaMessage = 'Description is too short';
      this.lambdaError = true;
      return;
    }

    this.formValid = true;
  }

}
